import React, {useEffect, useMemo, useState} from 'react';
import { Box, TextField, Button, Grid, Radio, FormControl, FormLabel, RadioGroup,FormControlLabel
} from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from 'notistack';
import { cancelLibraryBooking, getLibraryBookingCancellationReasons } from 'services/bookings';
import ControlPointIcon from '@mui/icons-material/ControlPoint';

const CancelBooking = ({bookingId, onBookingCancelled}) => {
  const defaultFormFields = useMemo(() =>({cancellationReason: '', otherReasonText: ''}), []);
  const [cancellationReasons, setCancellationReasons] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const { handleSubmit, control, formState: { errors }, watch, reset } = useForm({
    mode: 'onTouched',
    defaultValues: {...defaultFormFields}
  });

  useEffect(() => {
    getLibraryBookingCancellationReasons().then(({response, error}) => {
      if(response){ 
        setCancellationReasons([...response]);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, []);
  

  const onSubmit = (data) => {
    const postData = {
      bookingId,
      cancellationReason: data.cancellationReason === 'Other' ? data.otherReasonText : data.cancellationReason
    }
    cancelLibraryBooking({
      ...postData,
    }).then(({response, error}) => {
      if(response){
        enqueueSnackbar((`Booking cancelled successfully`), {variant: 'success'});
        reset();
        onBookingCancelled();
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  return (
    <Box noValidate component="form"  onSubmit={handleSubmit(onSubmit)} >
      <Grid container spacing={3} alignItems="center"  direction="row">
      <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt: 1}}>
          <FormControl error={!!errors?.type} >
            <FormLabel id="reason-type-group-label">Reason for cancellation</FormLabel>
            <Controller
              control={control}
              name="cancellationReason"
              id="cancellationReason"
              required
              rules={{ required: "Select cancellation reason" }}
              render={({field}) => (
                <RadioGroup
                  {...field}
                  aria-labelledby="reason-type-group-label"
                  name="cancellationReason"
                >
                  {cancellationReasons.map((reason, index) => (
                    <FormControlLabel key={index} value={reason} control={<Radio />} label={reason} />
                  ))}
                </RadioGroup>
              )}
            />
          </FormControl>
        </Grid> 
        {watch('cancellationReason') === 'Other' ? <Grid item xs={12} sm={12} md={12} lg={12}>
          <Controller
            control={control}
            name="otherReasonText"
            id="otherReasonText"
            rules={{ required: "Enter cancellation reason",
            }}
            render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="Type reason here"
                required
                error={!!errors?.otherReasonText}
                size="small"
                fullWidth
                multiline
                rows={3}
              />
            )}
          />
        </Grid> : null}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: 3, mb: 2, textTransform: 'inherit' }}
            startIcon={<ControlPointIcon />}
            color="primary"
          >
            Cancel Booking
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
 

export default React.memo(CancelBooking);
